import React from "react";

import FeedbackHeader from "../../layout/FeedbackHeader";
import FeedbackRating from "../Input/FeedbackRating";

import { FeedbackFormLayout } from "../../layout/FeedbackFormLayout";

export const Question5FlashCoachExperience = ({
  flashCoachPlatformRating,
  updateRatingFormData,
}) => {
  return (
    <>
      <FeedbackFormLayout
        title={"Experience with FLASH Coach"}
        subtitle={
          "Tell us about your experience using the platform and what you’d improve."
        }
      >
        <FeedbackHeader
          title={
            "How would you rate your overall experience with our coaching system?"
          }
        />
        <FeedbackRating
          inputID={"flashCoachPlatformRating"}
          rating={flashCoachPlatformRating}
          updateRatingFormData={updateRatingFormData}
        />
      </FeedbackFormLayout>
    </>
  );
};
